<template>
  <div class="w-full max-w-full p-2 sm:p-4 lg:p-6">
    <!-- Page Title -->
    <div class="font-semibold text-lg sm:text-xl lg:text-2xl mb-3 sm:mb-4 lg:mb-6 text-gray-800">
      Overall school List
    </div>
    <!-- Responsive DataTable Container -->
    <div class="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
      <DataTable
        :value="customers1"
        :paginator="true"
        :rows="10"
        dataKey="pid"
        :rowHover="true"
        v-model:filters="filters1"
        @filter="onTableFilter"
        filterDisplay="menu"
        :loading="loading1"
        :globalFilterFields="['name', 'address1','address2','level','head_officer','area_size']"
        showGridlines
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        :rowsPerPageOptions="[5, 10, 25, 100, 1000, 10000]"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} schools"
        class="responsive-datatable"
      >
        <template #header>
          <!-- Mobile Header (Stacked Layout) -->
          <div class="block lg:hidden p-3 space-y-3 bg-gray-50 border-b">
            <!-- Search -->
            <div class="w-full">
              <IconField>
                <InputIcon>
                  <i class="pi pi-search text-sm" />
                </InputIcon>
                <InputText
                  v-model="globalSearchValue"
                  @input="updateGlobalFilter"
                  placeholder="Search schools..."
                  class="w-full text-sm"
                />
              </IconField>
            </div>

            <!-- Filters Grid -->
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-2">
              <MultiSelect
                v-model="schoolLvlValue"
                :options="schoolLvlList"
                placeholder="School Level"
                class="w-full text-xs"
              />
              <MultiSelect
                v-model="schoolDisValue"
                :options="schoolDisList"
                placeholder="District"
                class="w-full text-xs"
              />
              <Button
                @click="submitFilter"
                label="Filter"
                severity="info"
                raised
                :loading="loading1"
                class="w-full text-xs py-2 sm:col-span-2"
                size="small"
              />
            </div>

            <!-- Action Button -->
            <div class="w-full">
              <Button
                v-if="authStore.roles.includes('addSchool')"
                label="Add School"
                severity="info"
                raised
                @click="showDialog = true"
                class="w-full text-sm"
                icon="pi pi-plus"
                size="small"
              />
            </div>
          </div>

          <!-- Desktop Header (Original Layout) -->
          <div class="hidden lg:block p-4 bg-gray-50 border-b">
            <div class="flex flex-col lg:flex-row lg:justify-between lg:items-start gap-3">
              <!-- Filters Section -->
              <div class="flex flex-wrap gap-3 flex-1">
                <IconField>
                  <InputIcon>
                    <i class="pi pi-search" />
                  </InputIcon>
                  <InputText
                    v-model="globalSearchValue"
                    @input="updateGlobalFilter"
                    placeholder="Keyword Search"
                    class="w-80 xl:w-96"
                  />
                </IconField>
                <MultiSelect
                  v-model="schoolLvlValue"
                  :options="schoolLvlList"
                  placeholder="School Level"
                  class="w-48"
                />
                <MultiSelect
                  v-model="schoolDisValue"
                  :options="schoolDisList"
                  placeholder="School District"
                  class="w-48"
                />
                <Button
                  @click="submitFilter"
                  label="Submit Filters"
                  severity="info"
                  raised
                  :loading="loading1"
                  class="whitespace-nowrap"
                />
              </div>

              <!-- Action Button -->
              <div class="lg:ml-4">
                <Button
                  v-if="authStore.roles.includes('addSchool')"
                  label="Add School"
                  severity="info"
                  raised
                  @click="showDialog = true"
                  class="whitespace-nowrap"
                />
              </div>
            </div>
          </div>
        </template>

        <template #empty>
          <div class="text-center py-6 text-gray-500">
            <i class="pi pi-building text-3xl mb-3 block text-gray-400"></i>
            <p class="text-base font-medium">No schools found</p>
            <p class="text-sm text-gray-400">Try adjusting your search criteria</p>
          </div>
        </template>

        <template #loading>
          <div class="text-center py-6">
            <i class="pi pi-spin pi-spinner text-2xl text-blue-500 mb-2"></i>
            <p class="text-gray-600">Loading schools data. Please wait.</p>
          </div>
        </template>

        <!-- School Name Column - Always visible -->
        <Column
          field="name"
          filterField="name"
          header="School Name"
          style="min-width: 200px"
          frozen
          class="name-column"
        >
          <template #body="{ data }">
            <div class="text-lg sm:text-sm lg:text-base font-medium text-gray-900 leading-tight">
              <div class="truncate max-w-[140px] sm:max-w-[180px] lg:max-w-none" :title="data.name">
                {{ data.name }}
              </div>
              <!-- Mobile-only additional info -->
              <div class="block md:hidden text-xs text-gray-500 mt-1">
                <div class="truncate text-sm ">{{ data.address1 }}, {{ data.address2 }}</div>
                <div>{{ data.head_officer ? `Principal: ${data.head_officer}` : 'No Principal Listed' }}</div>

             <div class="block md:hidden">

            <div class="block lg:hidden mt-3">
              <Button
                v-if="authStore.roles.includes('viewSchool')"
                type="button"
                label="View"
                icon="pi pi-eye"
                @click="router.push(`/school/profile/${data.pid}`)"
                severity="primary"
                size="small"
                class="w-full text-xs py-1"
              />
            </div>
            <div class="block lg:hidden">
              <Button
                v-if="authStore.roles.includes('deleteSchool')"
                type="button"
                label="Delete"
                icon="pi pi-eye"
                @click="requestDelete(data.pid)"
                severity="danger"
                size="small"
                class="w-full text-xs py-1 mt-2"
              />
            </div>
             </div>
              </div>
            </div>
          </template>
        </Column>

        <!-- Address Column - Hidden on mobile -->
        <Column
          header="Address"
          filterField="address1"
          style="min-width: 150px"
          class="hidden md:table-cell"
        >
          <template #body="{ data }">
            <div class="text-sm text-gray-600 truncate max-w-[130px]" :title="data.address1">
              {{ data.address1 || 'N/A' }}
            </div>
          </template>
        </Column>


        <!-- School Level Column - Always visible -->
        <Column
          header="Level"
          filterField="level"
          style="min-width: 120px"
          class="hidden md:table-cell"
        >
          <template #body="{ data }">
            <span class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium"
                  :class="getSchoolLevelClass(data.level)">
              {{ data.level || 'N/A' }}
            </span>
          </template>
        </Column>

        <!-- Principal/OIC Column - Hidden on mobile and tablets -->
        <Column
          header="Principal/OIC"
          filterField="head_officer"
          style="min-width: 160px"
          class="hidden lg:table-cell"
        >
          <template #body="{ data }">
            <div class="text-sm text-gray-600 truncate max-w-[140px]" :title="data.head_officer">
              {{ data.head_officer || 'Not Assigned' }}
            </div>
          </template>
        </Column>

        <!-- Location Column - Hidden on mobile -->
        <Column
          header="Non Teaching"
          filterField="address2"
          style="min-width: 120px"
          class="hidden md:table-cell"
        >
          <template #body="{ data }">
            <div class="text-sm text-gray-600 truncate max-w-[100px]" :title="data.address2">
              {{ data.non_teaching_count || '0' }}
            </div>
          </template>
        </Column>

        <!-- School Size Column - Hidden on mobile and tablets -->
        <Column
          header="Teacher Count"
          filterField="area_size"
          style="min-width: 120px"
          class="hidden lg:table-cell"
        >
          <template #body="{ data }">
            <div class="text-sm text-gray-600">
              {{ data.teachers_count || 0 }}
            </div>
          </template>
        </Column>

        <!-- Date Created Column - Hidden on mobile and tablets -->
        <Column
          header="Student Count"
          filterField="date_founded"
          style="min-width: 120px"
          class="hidden xl:table-cell"
        >
          <template #body="{ data }">
            <div class="text-sm text-gray-600">
              {{ data.students_count || '0' }}
            </div>
          </template>
        </Column>

        <!-- Actions Column - Always visible -->
        <Column
          header="Actions"
          bodyClass="text-center"
          style="min-width: 100px"
          class="hidden md:table-cell"
        >
          <template #body="{ data }">
            <!-- Mobile Actions -->
             <div class="block md:hidden">

            <div class="block lg:hidden">
              <Button
                v-if="authStore.roles.includes('viewSchool')"
                type="button"
                label="View"
                icon="pi pi-eye"
                @click="router.push(`/school/profile/${data.pid}`)"
                severity="primary"
                size="small"
                class="w-full text-xs py-1"
              />
            </div>
            <div class="block lg:hidden">
              <Button
                v-if="authStore.roles.includes('deleteSchool')"
                type="button"
                label="Delete"
                icon="pi pi-eye"
                @click="requestDelete(data.pid)"
                severity="danger"
                size="small"
                class="w-full text-xs py-1"
              />
            </div>
             </div>

            <div class="hidden md:flex justify-center items-center gap-2">

            <div class="hidden lg:flex justify-center items-center">
              <Button
                v-if="authStore.roles.includes('viewSchool')"
                type="button"
                label="View"
                v-tooltip="'View Profile'"
                icon="pi pi-eye"
                @click="router.push(`/school/profile/${data.pid}`)"
                severity="primary"
                size="small"
              />
            </div>
            <div class="hidden lg:flex justify-center items-center">
              <Button
                v-if="authStore.roles.includes('deleteSchool')"
                type="button"
                label="Delete"
                v-tooltip="'Delete Profile'"
                icon="pi pi-times"
                @click="requestDelete(data.pid)"
                severity="danger"
                size="small"
              />
            </div>
            </div>
            <!-- Desktop Actions -->
          </template>
        </Column>
      </DataTable>
    </div>

    <!-- Add School Dialog -->
    <Dialog
      v-model:visible="showDialog"
      modal
      :style="getDialogStyle()"
      :breakpoints="{ '960px': '75vw', '641px': '95vw' }"
      header="Add School"
      class="responsive-dialog"
    >
      <CreateSchoolPageView @close="showDialog = false" />
    </Dialog>

            <Dialog header="Confirm Delete" v-model:visible="showDeleteDialog" modal :style="{ width: '400px' }">
              <p>Are you sure you want to delete this school?</p>
              <div class="flex justify-end gap-2 mt-4">
                <Button label="Cancel" class="p-button-secondary" @click="cancelDelete" />
                <Button label="Delete" class="p-button-danger" @click="confirmDelete" />
              </div>
            </Dialog>
    <Toast position="top-right" />
  </div>
</template>

<script setup>
import { FilterMatchMode, FilterOperator } from '@primevue/core/api'
import { onMounted, ref, watch, computed } from 'vue'
import { storeToRefs } from 'pinia'
import * as XLSX from 'xlsx'
import router from '@/router'
import CreateSchoolPageView from './School/CreateSchoolPageView.vue'
import { useSchoolStore } from '@/store/admin/StoreSchool'
import { useAuthStore } from '../../auth/auth'
import { useGradeStore } from '@/store/admin/GradeLevelStore'
import { useToast } from 'primevue/usetoast';

const schoolStore = useSchoolStore()
const { schools } = storeToRefs(schoolStore)
const toast = useToast()

const glevelStore = useGradeStore()
const { grade } = storeToRefs(glevelStore)

const authStore = useAuthStore()
// Responsive dialog helper
const getDialogStyle = () => {
  if (typeof window !== 'undefined') {
    if (window.innerWidth < 768) {
      return { width: '95vw', maxHeight: '90vh' }
    } else if (window.innerWidth < 1024) {
      return { width: '75vw', maxHeight: '85vh' }
    }
  }
  return { width: '90vw', maxWidth: '600px', maxHeight: '80vh' }
}

// School level styling helper
const getSchoolLevelClass = (level) => {
  switch (level?.toLowerCase()) {
    case 'elementary':
    case 'primary':
      return 'bg-green-100 text-green-800'
    case 'secondary':
    case 'high school':
      return 'bg-blue-100 text-blue-800'
    case 'senior high':
    case 'senior high school':
      return 'bg-purple-100 text-purple-800'
    case 'kindergarten':
    case 'pre-school':
      return 'bg-yellow-100 text-yellow-800'
    default:
      return 'bg-gray-100 text-gray-800'
  }
}

// Date formatting helper
const formatDate = (dateString) => {
  if (!dateString) return null
  try {
    const date = new Date(dateString)
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: '2-digit'
    })
  } catch (error) {
    return dateString
  }
}

const customers1 = ref([])
const filters1 = ref({})
const loading1 = ref(false)
const showDialog = ref(false)
const displayedStudents = ref([])

const globalSearchValue = ref('')

// School filter options
const schoolLvlList = ref([])
const schoolLvlValue = ref([])
const schoolDisList = ref(['San Fernando'])
const schoolDisValue = ref([])

function initFilters1() {
  filters1.value = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    name: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    address1: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    address2: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    level: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    head_officer: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    area_size: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    date_founded: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
  }
}

let globalFilterTimeout = null
const updateGlobalFilter = () => {
  if (globalFilterTimeout) {
    clearTimeout(globalFilterTimeout)
  }

  globalFilterTimeout = setTimeout(() => {
    if (filters1.value?.global) {
      filters1.value.global.value = globalSearchValue.value
    }
  }, 300)
}

onMounted(async () => {
  loading1.value = true
  await glevelStore.getGrades()
  schoolLvlList.value = grade.value.map(item => item.name)
  try {
    initFilters1() // Initialize filters first
    await schoolStore.fetchData() // Then fetch data
  } catch (error) {
    console.error('Error initializing component:', error)
  } finally {
    loading1.value = false
  }
})


watch(schools, (newVal) => {
  if (newVal && Array.isArray(newVal)) {
    customers1.value = [...newVal]
  }
}, { immediate: false })


const deleteIndex = ref(null);
const showDeleteDialog = ref(false);

const requestDelete = (index) => {
  deleteIndex.value = index;
  showDeleteDialog.value = true;
};

const cancelDelete = () => {
  showDeleteDialog.value = false;
  deleteIndex.value = null;
};

const confirmDelete = async () => {
  if (deleteIndex.value !== null) {
  const ret = await schoolStore.deleteSchool(deleteIndex.value)
    if (ret.success) {
      toast.add({
        severity: 'success',
        summary: 'Deleted! 🎉',
        detail: `School deleted successfully.`,
        life: 5000
      });
    } else {
      toast.add({
        severity: 'error',
        summary: 'Failed!',
        detail: `Failed to delete school.`,
        life: 5000
      });
    }
  }
  showDeleteDialog.value = false;
  deleteIndex.value = null;
};


const onTableFilter = (event) => {
  displayedStudents.value = event.filteredValue || []
}

const submitFilter = async () => {
  if (loading1.value) return

  loading1.value = true
  try {
    if (schoolLvlValue.value && schoolLvlValue.value.length > 0 || schoolDisValue.value && schoolDisValue.value.length > 0 ) {
      await schoolStore.fetchDataWithParams(schoolLvlValue.value.join(','), schoolDisValue.value.join(','))
    } else {
      await schoolStore.fetchData()
    }
  } catch (error) {
    console.error('Error filtering schools:', error)
  } finally {
    loading1.value = false
  }
}

</script>

<style scoped>
.form-container {
  min-width: unset; /* Remove fixed min-width for mobile responsiveness */
  margin: 0 auto;
  padding: 1rem; /* Add padding for better spacing on all screens */
  max-width: 1200px; /* Optional: Constrain max width on large screens */
}

/* Custom styles for DataTable responsiveness on mobile */
/* These styles will kick in for smaller screens to make the table columns stack */
@media screen and (max-width: 960px) {
  .p-datatable.p-datatable-responsive-mobile .p-datatable-thead > tr > th,
  .p-datatable.p-datatable-responsive-mobile .p-datatable-tfoot > tr > td {
    display: none !important; /* Hide original table headers/footers */
  }

  .p-datatable.p-datatable-responsive-mobile .p-datatable-tbody > tr > td {
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: space-between; /* Space out label and value */
    width: 100%;
    padding: 0.5rem 1rem;
    border: 0 none;
    border-top: 1px solid var(--surface-d); /* Separator between "rows" of data */
  }

  .p-datatable.p-datatable-responsive-mobile .p-datatable-tbody > tr > td:last-child {
    border-bottom: 1px solid var(--surface-d); /* Bottom border for the last cell in a stacked row */
  }

  .p-datatable.p-datatable-responsive-mobile .p-datatable-tbody > tr > td:first-child {
    background: var(--surface-b); /* Highlight the first item (e.g., Name) */
    font-weight: 600;
  }

  /* Label for each row data - uses the 'data-p-field' attribute from PrimeVue's internal structure */
  .p-datatable.p-datatable-responsive-mobile .p-datatable-tbody > tr > td::before {
    content: attr(data-p-field) ":"; /* Displays the column header as a label */
    font-weight: 600;
    margin-right: 0.5rem;
    display: inline-block;
  }
}

/* General layout adjustments for smaller screens */
@media (max-width: 768px) {
  /* Ensure header elements stack nicely */
  .p-datatable-header .flex {
    flex-direction: column;
    align-items: flex-start; /* Align stacked items to the start */
  }

  /* Make sure individual inputs and buttons within header take full width on mobile */
  .p-datatable-header .p-inputtext,
  .p-datatable-header .p-multiselect, /* (if MultiSelect was here) */
  .p-datatable-header .p-button {
    width: 100%;
  }

  /* Adjust gaps for stacked elements */
  .p-datatable-header .flex-column > .flex-column {
    gap: 0.75rem; /* Smaller gap for stacked inner groups */
  }
}
</style>
